import type { SVGProps } from "react";

// Иконки из Figma (Assets / Icon Library), геометрия без изменений.
// Цвет штриха — currentColor, чтобы активное и обычное состояния задавались через CSS `color`.

type IconProps = SVGProps<SVGSVGElement>;

/** Icon / Arrow Back. */
export function ArrowBackIcon(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" {...props}>
      <path d="M8.75025 3.75L3.75 10.0003" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.75 9.99969L8.75025 16.25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.75 10H16.25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

/** Icon / Arrow Forward в размере чипа шапки (Status / Device Activity). */
export function ArrowForwardIcon(props: IconProps) {
  return (
    <svg width="17.667" height="17.667" viewBox="0 0 17.6667 17.6667" fill="none" aria-hidden="true" {...props}>
      <path d="M9.93728 14.2604L14.3542 8.73932" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.3542 9.26067L9.93728 3.73956" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13 8H3" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}

/** Home из Navigation / Bottom. */
export function HomeIcon(props: IconProps) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true" {...props}>
      <path
        d="M25.2083 12.0833V25.2083C25.2083 26.8192 23.9025 28.125 22.2917 28.125H7.70833C6.0975 28.125 4.79167 26.8192 4.79167 25.2083V12.0833M28.125 15L15 1.875L1.875 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Icon / Camera из Navigation / Bottom: таб «E-va». */
export function DeviceIcon(props: IconProps) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true" {...props}>
      <path
        d="M2.14286 8.78908V24.2857C2.14286 25.8636 3.42204 27.1428 5 27.1428H25C26.578 27.1428 27.8571 25.8636 27.8571 24.2857V8.78908M27.8573 24.732V9.37494C27.8573 7.30387 26.5781 5.62494 25.0001 5.62494H5.00013C3.42217 5.62494 2.14299 7.30388 2.14299 9.37494V24.732"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle cx="15" cy="22.5" r="1.875" fill="currentColor" />
      <path d="M22.1428 2.8571L24.9999 2.8571" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Icon / Profile из Navigation / Bottom. */
export function ProfileIcon(props: IconProps) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true" {...props}>
      <path
        d="M1.66657 25C1.66657 21.3181 4.65133 18.3333 8.33323 18.3333H21.6666C25.3485 18.3333 28.3332 21.3181 28.3332 25C28.3332 26.8409 26.8408 28.3333 24.9999 28.3333H4.9999C3.15895 28.3333 1.66657 26.8409 1.66657 25Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle cx="15" cy="6.66672" r="5" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

/** Icon / Attachment 12px — отметка «Закреплено» (Figma 295:1813). */
export function PinIcon(props: IconProps) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" {...props}>
      <path
        d="M2.50012 7.75L2.50012 4.25C2.50012 2.317 4.06713 0.75 6.00012 0.75C7.93312 0.75 9.50012 2.317 9.50012 4.25V8.91667C9.50012 10.2053 8.45545 11.25 7.16679 11.25C5.87812 11.25 4.83346 10.2053 4.83346 8.91667V4.25C4.83346 3.60567 5.35579 3.08333 6.00012 3.08333C6.64445 3.08333 7.16679 3.60567 7.16679 4.25L7.16679 8.91667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Icon / More 16px — меню карточки сообщения (Figma 295:1672): три точки. */
export function MoreIcon(props: IconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" {...props}>
      <circle cx="2" cy="8" r="1.25" />
      <circle cx="8" cy="8" r="1.25" />
      <circle cx="14" cy="8" r="1.25" />
    </svg>
  );
}

/** Icon / Close 16px (Figma 303:1793): крестик. */
export function CloseIcon(props: IconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <path d="M12 4L4.00056 11.9994" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 4L11.9994 11.9994" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Icon / Flash из сканера QR (Figma 682:6452): фонарик. */
export function FlashIcon(props: IconProps) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" aria-hidden="true" {...props}>
      <path d="M8.55 21.15L19.575 2.24995V14.85H27.45L16.425 33.7499V21.15H8.55Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

/** Icon / Repeat из сканера QR (Figma 682:6455): смена камеры. */
export function SwitchCameraIcon(props: IconProps) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
      <path
        d="M2 15.9996C2 8.26786 8.26784 2.00001 15.9996 2.00001C20.3975 2.00001 24.3217 4.02789 26.8882 7.19958"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M27.6663 2.00002L27.6663 8.22207L21.4443 8.22207" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M30 15.9996C30 23.7314 23.7322 29.9993 16.0004 29.9993C11.6025 29.9993 7.67832 27.9714 5.11179 24.7997"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.33365 29.9993L4.33365 23.7772L10.5557 23.7772" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Icon / Wi-Fi из Device / Connection Card: круг цвета статуса (currentColor) со светлыми штрихами. */
export function WiFiStatusIcon(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" {...props}>
      <circle cx="9.99695" cy="10" r="10" fill="currentColor" />
      <path
        d="M5 7.5H15M6.875 10.625H13.125M9.375 13.75H10.625"
        stroke="var(--color-neutral-light-light)"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
